import { Component, Inject, inject } from '@angular/core';
import { BottomSheetTitleComponent } from '../bottom-sheet-title/bottom-sheet-title.component';
import { BottomSheetControlsComponent } from '../../bottom-sheet-controls/bottom-sheet-controls.component';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheet,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { DetailedEntry } from 'src/services/entry/EntryWithDetails';
import { DetailedTag } from 'src/services/tag/DetailedTag';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatListModule,
  MatSelectionList,
  MatSelectionListChange,
} from '@angular/material/list';
import { CommonModule, DatePipe } from '@angular/common';
import { getTopLevelTag } from 'src/utils/getTopLevelTag';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EntryService } from 'src/services/entry/entry.service';
import { getTagColor } from 'src/utils/getTagColor';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'edit-entry-bottom-sheet',
  standalone: true,
  imports: [
    BottomSheetTitleComponent,
    BottomSheetControlsComponent,
    FormsModule,
    MatListModule,
    DatePipe,
    MatDatepickerModule,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
    MatBottomSheetModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './edit-entry-bottom-sheet.component.html',
  styleUrl: './edit-entry-bottom-sheet.component.scss',
})
export class EditEntryBottomSheetComponent {
  public _bottomSheetRef =
    inject<MatBottomSheetRef<EditEntryBottomSheetComponent>>(MatBottomSheetRef);

  newEntry: DetailedEntry = { ...this.data.entry };
  dateFormControl = new FormControl(new Date(this.newEntry.date!));

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { entry: DetailedEntry; tags: DetailedTag[] },
    private entryService: EntryService,
    private _snackBar: MatSnackBar
  ) {}

  getTopLevelTag = getTopLevelTag;
  getTagColor = getTagColor;

  updateEntry() {
    const entry = { ...this.newEntry };
    // @ts-ignore

    delete entry.tags;

    this.entryService.put(entry);
    this._bottomSheetRef.dismiss();
  }

  updateNewEntryTags(event: MatSelectionListChange) {
    const ids = event.source.selectedOptions.selected.map(
      (option) => option.value
    );

    this.newEntry.tagIds = ids;
  }

  async deleteEntry() {
    if (confirm('Delete Entry?')) {
      if (this.data.entry.id) {
        await this.entryService.delete(this.data.entry.id);
        this._snackBar.open('Entry deleted successfully');
        this._bottomSheetRef.dismiss();
      } else {
        this._snackBar.open('Error: Entry ID was not found. Please try again.');
        this._bottomSheetRef.dismiss();
      }
    }
  }
}
